import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

import { parseQueryString } from '../../shared/utils';

import {
  loadActiveUser,
  loadUser
} from '../../shared/redux/entities/actions';

import {
  requestAuthTokenWithCredentials
} from '../../shared/redux/auth/actions';

function mapStateToProps(state,props){
  return {
    isInvite:props.location.pathname.indexOf('invite') >= 0,
    queryStringParams:parseQueryString(props.location.search)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadActiveUser,
    loadUser,
    requestAuthTokenWithCredentials
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/OnboardingSignup/connect.js